// Session guard: clear an invalid/stale session and send the user to /login on
// any 401 from an authenticated call.
//
// Why: the client decides "logged in" from the mere presence of a token and only
// checks its EXPIRY (App.js), not its signature. After a JWT secret rotation, old
// tokens are unexpired but fail verification, so every authenticated call returns
// 401 and the dashboard renders with no data and crashes to a blank page
// (AISC issues#4). This installs a global 401 handler for both axios and fetch so
// the app fails safe: drop the token and go to login instead of hanging broken.
//
// Self-installs on import. Import it FIRST in index.js so it is active before any
// component makes a request.
import axios from "axios";

function onAuthPage() {
  var p = (window.location.pathname || "").replace(/\/+$/, "");
  return p === "/login" || p === "/signup";
}

export function forceLogout() {
  try {
    localStorage.removeItem("jwtToken");
  } catch (e) {
    /* ignore storage errors */
  }
  if (!onAuthPage()) {
    // replace() so the broken dashboard is not left in history
    window.location.replace("/login");
  }
}

function handle401(status) {
  if (status !== 401) return;
  // Only act when we actually hold a token; a 401 from the login attempt itself
  // (wrong password, no token) must not trigger a redirect loop.
  var hasToken = false;
  try {
    hasToken = !!localStorage.getItem("jwtToken");
  } catch (e) {
    return;
  }
  if (hasToken) forceLogout();
}

// --- axios: default instance used across the app (Authorization header) ---
axios.interceptors.response.use(
  function (res) {
    return res;
  },
  function (error) {
    if (error && error.response) handle401(error.response.status);
    return Promise.reject(error);
  }
);

// --- fetch: dashboard and others call fetch() directly with x-access-token ---
if (typeof window !== "undefined" && typeof window.fetch === "function") {
  var originalFetch = window.fetch.bind(window);
  window.fetch = function () {
    return originalFetch.apply(null, arguments).then(function (res) {
      try {
        handle401(res.status);
      } catch (e) {
        /* never let the guard throw */
      }
      return res;
    });
  };
}
